import { useMemo, useState } from "react";
import leftLogo from "../../assets/ConnectUmmah.png";
//import rightLogo from "../../assets/Bramalea.png";
import AnnouncementTicker from "./AnnouncementTicker";

const CDN_BASE = "https://cdn.connectummah.com/myuploadfiles";

function resolveLogoSrc(logo_Url) {
  if (!logo_Url) return null;

  const raw = String(logo_Url).trim();
  if (!raw) return null;

  // base64/data url support
  if (/^data:image\//i.test(raw)) return raw;

  // absolute url support
  if (/^https?:\/\//i.test(raw)) return raw;

  // relative path -> assume CDN
  return `${CDN_BASE}${raw.startsWith("/") ? "" : "/"}${raw}`;
}

const FooterStrip = ({ colorSettings, announcements, logo_Url }) => {
  const backgroundColor = colorSettings?.backgroundColor || "white";
  const [logoBroken, setLogoBroken] = useState(false);

  const rightLogoSrc = useMemo(() => {
    setLogoBroken(false); // reset when prayerData logo changes
    return resolveLogoSrc(logo_Url);
  }, [logo_Url]);

  const showRightLogo = !!rightLogoSrc && !logoBroken;

  return (
    <div
      className="text-[rgb(33,37,41)] m-0 p-0 flex w-full items-center justify-between box-border h-[10svh]"
      style={{ backgroundColor }}
    >
      {/* Left Logo */}
      <div className="flex items-center mb-0">
        <img src={leftLogo} alt="Left Logo" className="w-[14svh]" />
      </div>

      {/* Center Announcement Ticker */}
      <div className="flex-1 flex items-center justify-center px-2 relative">
        <div className="w-[100%] overflow-hidden">
          <AnnouncementTicker announcements={announcements} />
        </div>
      </div>

      {/* Right Logo (from API: prayerData.logo_Url) */}
      <div className="flex items-center justify-end pr-2">
        {showRightLogo ? (
          <img
            src={rightLogoSrc}
            alt="Right Logo"
            className="w-[14svh]"
            onError={() => setLogoBroken(true)}
          />
        ) : null}
      </div>
    </div>
  );
};

export default FooterStrip;
